<template>
  <!-- :style="{ border: (boxshow === false ? 'none' : '') }" -->
  <div class="filter-more">
    <p v-if="constName" class="text-toggle" @click="togglebox">
      {{ btnTxt ? '更多筛选' : '收起筛选' }}
      <svg-icon :icon-class="btnTxt ? 'xia' : 'shang'" />
    </p>
    <transition name="selectbox">
      <div class="box" style="min-height:50px;">
        <template v-for="(item, index) in filterBox">
          <div
            v-if="
              (!selectBox.find(itemfs => (item.propId == itemfs.index && item.propId < 1)) && boxshow && item.items.length)
                || (item.name == '品牌:' || item.name == '标准类别:')"
            :key="index"
            class="filter-box"
          >
            <div class="filter-title">{{ item.name }}</div>
            <div class="filter-item" :style="{ height: (changeHeight == index ? 'auto' : '50px') }">
              <!-- 如果是品牌并且要改变高度，则品牌筛选显示 -->
              <p v-if="index === 0 && changeHeight == index" class="all-en">
                <span class="all-en-title" style="cursor: pointer;" @click="handleEnClick('all')">所有品牌</span>
                <span
                  v-for="(enItem, enIndex) in getEN()"
                  :key="enIndex"
                  :class="[nowEnIndex === enIndex ? 'EnActive' : '', 'all-en-item']"
                  @click="handleEnClick(enItem, enIndex)"
                >{{ enItem }}</span>
              </p>
              <!-- 如果显示更多，则给div高度，并且有滚动条 -->
              <div :style="{ height: (changeHeight == index ? '143px' : ''), overflow: 'auto' }">
                <span v-for="(v, i) in item.items" :key="i" class="text-filter">
                  <el-checkbox
                    v-if="item.allCheck"
                    v-model="v.active"
                    :label="v.text"
                    @change="clickrange(index, v, i, item.name)"
                  />
                  <span v-else :class="{ isActive: v.active }" @click="clickrange(index, v, i, item.name)">{{ v.text
                  }}</span>
                </span>
              </div>
              <p v-show="item.allCheck" class="filter-button">
                <el-button
                  :disabled="item.Temporary.length <= 0"
                  type="danger"
                  class="filter-button-sure"
                  @click="allCheckSure(index)"
                >确定</el-button>
                <el-button class="filter-button-cancel" @click="closeCheck(index)">取消</el-button>
              </p>
            </div>
            <div v-if="!item.allCheck && !item.checkNone" class="filter-right-box">
              <span
                class="filter-all-checkbox"
                @click="openCheck(index)"
                @mouseenter="ismore = index"
                @mouseleave="ismore = false"
              >
                多选<svg-icon :icon-class="ismore === index ? 'add-red' : 'add-black'" />
              </span>
            </div>
            <div v-if="item.items.length > 9" class="filter-right-box">
              <span class="filter-more-open" @click="getMore(index)">
                <template v-if="changeHeight == index">
                  收起
                  <svg-icon icon-class="shang" />
                </template>
                <template v-else>
                  更多
                  <svg-icon icon-class="xia" />
                </template>
              </span>
            </div>
          </div>
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
import pinyin from 'pinyin'
export default {
  filters: {
    filter_show(val) {
    }
  },
  props: {
    filterBox: {
      type: Array,
      default: function() {
        return []
      }
    },
    constName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      boxshow: false,
      ismore: false,
      btnTxt: true,
      searchList: [], // 要深拷贝的品牌列表
      nowEnIndex: -1, // 当前点击的英文索引
      selectBox: [], // 单选的选项
      allSelectBox: [], // 多选的选项
      changeHeight: -1, // 需要改变高度的地方
      filterBoxNo: [
        {
          name: '品牌:',
          allCheck: false,
          allCheckList: [],
          items: [
            // { value: '1', text: '博世(BOSCH)', active: false },
          ]
        },
        {
          name: '五金工具:',
          allCheck: false,
          allCheckList: [],
          items: [
            { value: 'allAge', text: '电动工具', active: false },
            { value: 'treeY', text: '手动工具', active: false },
            { value: 'fourteenY', text: '工具配件', active: false },
            { value: 'fortyY', text: '家用五金', active: false },
            { value: 'sixtyY', text: '工具组套', active: false },
            { value: 'enghtyY', text: '气动工具', active: false },
            { value: 'ninetyY', text: '仪器仪表', active: false }
          ]
        },
        {
          name: '电钻类:',
          allCheck: false,
          allCheckList: [],
          items: [
            { value: 'allSex', text: '冲击钻', active: false },
            { value: 'man', text: '起子机', active: false },
            { value: 'women', text: '电锤', active: false },
            { value: 'unknow', text: '电动螺丝刀', active: false }
          ]
        },
        {
          name: '额定电压:',
          allCheck: false,
          allCheckList: [],
          items: [
            { value: '1', text: '<4V', active: false },
            { value: '2', text: '5-12v', active: false },
            { value: '3', text: '13-20v', active: false },
            { value: '4', text: '21-40v', active: false },
            { value: '5', text: '41-60v', active: false },
            { value: '6', text: '261v以上', active: false }
          ]
        },
        {
          name: '工作方式:',
          allCheck: false,
          allCheckList: [],
          items: [
            { value: '1', text: '台式', active: false },
            { value: '2', text: '手持', active: false }
          ]
        }
      ]
    }
  },
  watch: {
    // searchList: {
    //   deep: true,
    //   handler: function(val) {
    //     console.log(val)
    //   }
    // }
  },
  mounted() {
    // 这里在进入项目时进行深拷贝一份品牌的数据，按字母筛选的时候使用，如果调用接口了在接口里去处理品牌列表的深拷贝
  },
  methods: {
    // 组件品名传参调用品名拷贝
    makeCopy() {
      this.$nextTick(() => {
        if (this.filterBox[0]) {
          this.searchList = JSON.stringify(this.filterBox[0].items)
        } else {
          this.searchList = JSON.stringify([])
        }
      })
    },
    // 筛选是否展示
    togglebox() {
      this.boxshow = !this.boxshow
      this.btnTxt = !this.btnTxt
    },
    /**
     * 点击每一个筛选项的时候
     * @param {parentIndex}   在那个类别里，类别的索引，比如品牌，工作方式的index
     * @param {childIndex}    当前点击的索引
     * @param {name}          当前点击的文字内容
     */
    clickrange(parentIndex, el, childIndex, name) {
      const list = this.filterBox[parentIndex].items
      const item = this.filterBox[parentIndex]
      if (!item.allCheck) {
        // 如果不是多选的情况
        item.allCheckList = []
        this.selectBox.forEach((its, ins) => {
          if (its.index == item.propId) {
            this.selectBox.splice(ins, 1)
          }
        })
        list.filter((v, i) => {
          if (i === childIndex) {
            v.active = !v.active // 选中和反选
            v.name = name
            v.index = item.propId
            if (v.active) {
              this.selectBox.unshift(v)
            }
            // 选中的数组
            this.$emit('getAdvance', this.selectBox)
          } else {
            v.active = false // 取消选中
            this.selectBox.filter((childEl, childI) => {
              if (childEl.active === false) {
                this.selectBox.splice(childI, 1) // 反选删除数组中的当前个
                this.$emit('getAdvance', this.selectBox)
              }
            })
          }
        })
      } else {
        // 如果是多选的情况
        const arrCheck = []
        list.forEach((v, i) => {
          if (v.active) {
            arrCheck.unshift(v) // 存入暂存区
          }
          if (i === childIndex) {
            v.name = name

            // this.$emit('getAdvance', this.allSelectBox)
          } else {
            item.allCheckList.filter((childEl, childI) => { })
          }
        })
        item.Temporary = arrCheck
      }
    },
    /**
     * 当前项开启多选
     */
    openCheck(index) {
      this.changeHeight = index
      this.filterBox[index].allCheck = true
    },
    /**
     * 关闭当前行的多学
     */
    closeCheck(index) {
      this.changeHeight = -1
      this.filterBox[index].allCheck = false
      const arrList = this.filterBox[index].items
      this.selectBox.forEach(item => {
        if (item.index == this.filterBox[index].propId) {
          if (item.list) {
            arrList.forEach(itemas => {
              if (item.list.indexOf(itemas) > -1) {
                itemas.active = true
              } else {
                itemas.active = false
              }
            })
          } else {
            arrList.forEach(itemas => {
              if ([item].indexOf(itemas) > -1) {
                itemas.active = true
              } else {
                itemas.active = false
              }
            })
          }
        }
      })
      this.filterBox[0].items = JSON.parse(this.searchList) // 把深拷贝后的品牌数据在点击后赋值过来，以便重新筛选
    },
    // 生成英文字母
    getEN() {
      const arr = []
      for (let i = 65; i < 91; i++) {
        arr.push(String.fromCharCode(i))
      }
      return arr
    },
    /**
     * 点击所有品牌的英文筛选
     * @param {enItem}  点击后的字母
     * @param {enIndex} 点击的字母索引
     */
    handleEnClick(enItem, enIndex) {
      const alphabet = [] // 索引字母数组
      this.filterBox[0].items = JSON.parse(this.searchList) // 把深拷贝后的品牌数据在点击后赋值过来，以便重新筛选
      if (enItem === 'all' || this.nowEnIndex === enIndex) return this.nowEnIndex = -1

      this.nowEnIndex = enIndex
      this.filterBox[0].items.forEach((item, index) => {
        // 获取目标数组每一项的 name 值
        const name = item.text
        // 获取每一个name值第一个字的大写首字母（传入的 name 是中文时默认得到大写字母，name 是英文时按照原字符串输出，可能是小写）
        const initial = String(pinyin(name)[0]).substring(0, 1).toUpperCase()

        // 给数组每一项增加名为 initial 的 key，值就是第一个字的大写首字母
        // 如果当前点击的字母和每一项的首字母一样，则放入筛选后的列表里

        if (enItem === initial) {
        //   console.log(enItem, initial, this.filterBox[0].items[index])
          alphabet.push(this.filterBox[0].items[index])
        }
      })
      // 使品牌列表等于筛选后的列表
      this.filterBox[0].items = alphabet
    },
    /**
     * 查看更多
     */
    getMore(index) {
      if (this.changeHeight === index) {
        this.changeHeight = -1
        this.filterBox[index].allCheck = false
      } else {
        this.changeHeight = index
      }
    },
    /**
     * 当前多选的确定按钮
     */
    allCheckSure(index) {
      let text = ''
      const list = []
      this.selectBox.forEach((its, ins) => {
        if (its.index == this.filterBox[index].propId) {
          this.selectBox.splice(ins, 1)
        }
      })
      this.filterBox[index].Temporary.forEach(item => {
        list.push(item)
        text += item.text + '、' // 这里把选中的每一项的文字拿出，方便展示
      })
      text = text.substring(0, text.lastIndexOf('、')) //  去掉最后一个、
      const arr = [
        {
          name: this.filterBox[index].Temporary[0].name,
          text,
          list,
          index: this.filterBox[index].propId
        }
      ]
      this.selectBox.unshift(...arr) // 解构出来放到选中的数组里
      this.$emit('getAdvance', this.selectBox)
      this.filterBox[index].allCheck = false // 点完确定按钮以后给多选变成false
    },
    /**
     * 删除当前的筛选项
     * @param {index} 父组件传过来的要删除的index，在子组件进行删除再返回给父组件
     */
    removeCurrentSelect(index, item) {
      if (item.text.indexOf('、') > 0) {
        // 如果item里有、说明是多选的
        const arr = item.text.split('、') // 把item根据、分割成数组
        this.filterBox.filter((el, i) => {
          el.items.filter((data, childIndex) => {
            arr.filter((data2, index2) => {
              // 用每一项和传过来的item的每一项做对比，找到对应项，把active变成false
              if (data.text === arr[index2]) {
                data.active = false
              }
            })
          })
        })
      } else {
        // 这里说明是单选的
        this.filterBox.filter((el, i) => {
          el.items.filter((data, childIndex) => {
            if (data.text === this.selectBox[index].text) {
              data.active = false
            }
          })
        })
      }
      this.selectBox.splice(index, 1)
      this.$emit('getAdvance', this.selectBox)
    },
    // 清空全部筛选项
    removeAllSelect(type) {
      this.selectBox.filter((item, index) => {
        this.filterBox.filter((el, elIndex) => {
          el.items.filter((el2, elIndex2) => {
            if (item.name === el2.name) {
              el2.active = false
            }
          })
        })
      })
      this.selectBox = []
      if (type !== 1) {
        this.$emit('getAdvance', this.selectBox)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-more {
    caret-color: transparent;
  width: 100%;
//   border: 1px solid #d2d2d2;
  position: relative;
  margin: 10px 0 40px;

  .EnActive {
    color: #ec212d;
    border: 1px solid #ec212d;
  }

  .all-en {
    width: 100%;
    height: 34px;
    line-height: 34px;
    padding-left: 9px;
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);

    .all-en-title {
      width: 60px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      background: #ffffff;
      border: 1px solid #ec212d;
      font-size: 12px;
      color: #ec212d;
      padding: 6px;
    }

    .all-en-item {
      line-height: 34px;
      padding: 6px;
      margin-left: 5px;
      font-size: 12px;
      color: #999999;
      cursor: pointer;
    }
  }

  .filter-box {
    display: flex;
    flex-direction: row;
    min-height: 38px;
    line-height: 38px;
    border-bottom: 1px solid #d2d2d2;
  }

  .filter-box:last-child {
    border: none;
  }

  .filter-title {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333;
    padding: 6px;
    width: 100px;
    background: #fff;
    flex: none;
  }

  .filter-item {
    padding: 6px;
    background: #fff;
    flex: 1;
    height: 50px;
    overflow: hidden;
  }

  .filter-button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 10px;

    .filter-button-sure {
      width: 52px;
      height: 24px;
      // opacity: 0.6;
      border-radius: 4px;
      color: #fff;
      margin-right: 10px;
    }

    .filter-button-cancel {
      background: #fff;
      color: #333;
      border: 1px solid #d2d2d2;
    }

    .filter-button-sure,
    .filter-button-cancel {
      width: 52px;
      height: 24px;
      border-radius: 4px;
      font-size: 12px;
      font-family: SimSun;
      font-weight: 400;
      line-height: 24px;
      text-align: center;
      padding: 0;
    }
  }

  .text-filter {
    text-align: center;
    width: 81px;
    height: 27px;
    line-height: 37px;
    display: inline-block;
    margin-right: 25px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    cursor: pointer;

    span {
      &:hover {
        color: #ec212d;
      }
    }
  }

  .filter-right-box {
      background: #fff;
    width: 100px;
    display: flex;
    align-items: center;
    justify-content: center;

    .filter-more-open,
    .filter-all-checkbox {
      width: 64px;
      height: 24px;
      border: 1px solid #d2d2d2;
      border-radius: 4px;
      text-align: center;
      line-height: 24px;
      font-size: 12px;
      font-family: SimSun;
      font-weight: 400;
      color: #333333;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    .filter-all-checkbox {
      .svg-icon {
        width: 20px;
        height: 20px;
      }

      &:hover {
        color: #ec212d;
      }
    }

    .filter-more-open .svg-icon {
      margin-left: 3px;
    }
  }
}

.box {
  height: auto;
  height: calc(100%);
  overflow: hidden;
}

.text-toggle {
  text-align: center;
  cursor: pointer;
  position: absolute;
  left: 50%;
  bottom: -28px;
  transform: translateX(-50%);
  display: inline-block;
  width: 88px;
  height: 28px;
  background: #fff;
  border-radius: 5px;
  font-size: 12px;
  color: #333;
  text-align: center;
  line-height: 28px;

  &:hover {
    // box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.2);
  }
}

// .selectbox-leave-active,
// .selectbox-enter-active {
//   transition: all 1s ease;
// }
.selectbox-leave-active,
.selectbox-enter {
  height: 0px !important;
}

.selectbox-leave,
.selectbox-enter-active {
  height: auto;
  // height: calc(100%);
}

.isActive {
  // background-color: #2989dd;
  // border-radius: 40px;
  color: #ec212d;
}
</style>
<style lang="scss">
</style>
